<template>
    <div style="text-align: center; padding:40px 0;">
        <div class="row">
            <img style="width: 100%; max-width: 300px; display: block; margin:0 auto;" :src="cdn_url+'/assets/community/images/card.png'" alt="card-img" id="card-img">
        </div>
        <div class="col">
            <qrcode-vue :value="hcid" :size="300" level="H" />
        </div>
        <div class="col">
        </div>
        <div class="col" style="padding:10px 0; color: #000;">
            <div id="card-label">Nomor Kartu</div>
            <div id="card-id" style="font-size: 20px; font-weight: bold;">{{ hcid }}</div>
        </div>
    </div>
</template>
<script>
import QrcodeVue from 'qrcode.vue';


export default {
    components: {
        QrcodeVue
    },
    data() {
        return {
            cdn_url:cdn_url,
            hcid:this.$route.params.hcid,
        };
    },
    created() {
        this.base_url = base_url;
    },
};
</script>

<style scoped lang="scss">
</style>
